import React, { FunctionComponent } from "react";
import DownloadLinksProps from "./DownloadLinkProps.interface";
import styles from "./DownloadLink.module.scss";
import IconViewer from "components/IconViewer/IconViewer";

const DownloadLink:FunctionComponent<DownloadLinksProps> = (props) => {
    const fileUrl = typeof props.content.asset.umbracoFile === "string"
        ? props.content.asset.umbracoFile
        : props.content.asset.umbracoFile.src;

    return (
        <div className={styles.link_wrapper}>
            <a className={styles.link} href={fileUrl} target="_blank" rel="noopener noreferrer" download>
                <IconViewer name="download" className={styles.download_icon} aspectRatioX={1} aspectRatioY={1} />
                {props.content.label}
            </a>
        </div>
    );
};

export default DownloadLink;
